import React from "react";
import ScopedListing from "./ScopedListing";
import { useI18n } from "../lib/i18n";

/* «Yeni gələnlər» admin-dəki bayraqla işləyir (`is_new_arrival`), kolleksiya
   üzvlüyü ilə yox — sahib açarı məhsulda çevirir və məhsul dərhal burada
   görünür. URL tarixi səbəbdən /collections/new-arrivals qalır: menyu, SEO
   və paylaşılmış linklər ona bağlıdır. */
const SCOPE = { new_arrivals: true };

export default function NewArrivalsPage() {
  const { t } = useI18n();
  return (
    <ScopedListing
      scope={SCOPE}
      path="/collections/new-arrivals"
      testId="new-arrivals-page"
      listName="new-arrivals"
      heroIndex={1}
      eyebrow={t("newarrivals.eyebrow", "Yeni mövsüm")}
      title={t("newarrivals.title", "YENİ GƏLƏNLƏR")}
      description={t(
        "newarrivals.description",
        "Kolleksiyaya ən son əlavə olunan parçalar — məhdud sayda.",
      )}
      emptyTitle={t("newarrivals.empty", "Hazırda yeni gələn məhsul yoxdur")}
      emptyDescription={t(
        "newarrivals.empty_help",
        "Yeni parçalar əlavə olunanda burada görünəcək. Bu arada kataloqa baxa bilərsiniz.",
      )}
    />
  );
}
